



















































import * as R from 'ramda';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { RepeatType } from '@/API';
import ExecutionTimeInput from '@/components/molecules/ExecutionTimeInput.vue';
import PeriodDateInput from '@/components/molecules/PeriodDateInput.vue';
import RepeatTypeSelect from '@/components/molecules/RepeatTypeSelect.vue';
import { i18n } from '@/plugins/i18n/i18n';
import { isEmptyArray, isToday } from '@/utils/CommonUtils';

enum ValidationError {
  NoDateFrom = 'jobScheduler.common.notSelectedPeriod',
  DateFromAfterDateTo = 'jobScheduler.common.dateToLessThanDateFrom',
  NoExecutionTime = 'jobScheduler.events.executionTimeNotInputted',
  NoSelectedDates = 'jobScheduler.common.notSelectedDates',
  NoSelectedDays = 'jobScheduler.common.notSelectedDays',
  NoError = '',
}

@Component({
  components: {
    ExecutionTimeInput,
    PeriodDateInput,
    RepeatTypeSelect,
  },
})
export default class ScheduleSettingCard extends Vue {
  @Prop()
  private title!: string;

  @Prop()
  private dateTo!: string;

  @Prop()
  private dateFrom!: string;

  @Prop()
  private from!: string;
  @Prop()
  private selectedRepeatType!: any;

  @Prop()
  private selectedDays!: number[];

  @Prop()
  private selectedWeekdays!: number[];

  @Prop({ required: false })
  private executionTime!: string | null;

  @Prop({ required: false, default: false })
  private showExecutionTimeInput!: boolean;

  @Prop()
  private allowFromToday!: boolean;

  @Prop({ required: false, default: false })
  private isReadOnly!: boolean;

  @Emit('changedDateFrom')
  private changeDateFrom(dateFrom: string): void {}

  @Emit('changedDateTo')
  private changeDateTo(dateTo: string): void {}

  @Emit('changedRepeatType')
  private changeRepeatType(selectedRepeatType: RepeatType): void {}

  @Emit('changedWeekdays')
  private changeWeekdays(selectedWeekdays: number[]): void {}

  @Emit('changedDays')
  private changeDays(selectedDays: number[]): void {}

  private get fromLabelText() {
    return this.isNotNoRepeat
      ? i18n.tc('jobScheduler.common.period.from')
      : this.from;
  }

  private get isNotNoRepeat() {
    return this.selectedRepeatType !== RepeatType.NoRepeat;
  }

  @Emit('changedExecutionTime')
  private changeExecutionTime(time: string | null): void {}

  private get validationErrorType(): ValidationError {
    if (!this.dateFrom) {
      return ValidationError.NoDateFrom;
    }

    if (
      this.selectedRepeatType !== RepeatType.NoRepeat &&
      this.dateTo &&
      new Date(this.dateTo) < new Date(this.dateFrom)
    ) {
      return ValidationError.DateFromAfterDateTo;
    }

    if (this.showExecutionTimeInput && !this.executionTime) {
      return ValidationError.NoExecutionTime;
    }

    if (
      this.selectedRepeatType === RepeatType.Monthly &&
      isEmptyArray(this.selectedDays)
    ) {
      return ValidationError.NoSelectedDates;
    }

    if (
      this.selectedRepeatType === RepeatType.Weekly &&
      isEmptyArray(this.selectedWeekdays)
    ) {
      return ValidationError.NoSelectedDays;
    }

    return ValidationError.NoError;
  }

  @Emit('validationErrorInScheduledSettingCard')
  private doesAnyErrorExists(): boolean {
    const isInvalid = this.validationErrorType !== ValidationError.NoError;
    return isInvalid;
  }

  private get validateErrorMessage() {
    return this.$t(this.validationErrorType);
  }
  private get cautionMessage() {
    if (this.isReadOnly) {
      return '';
    }

    const inputtedDateWithTime = new Date(
      R.join(' ', [this.dateFrom, this.executionTime])
    );
    const executionOrStartDateTime =
      this.selectedRepeatType === RepeatType.NoRepeat
        ? this.$t('jobScheduler.events.executionDateTime')
        : this.$t('jobScheduler.events.startDateTime');
    return this.executionTime &&
      isToday(this.dateFrom) &&
      inputtedDateWithTime <= new Date()
      ? `${executionOrStartDateTime}${this.$t(
          'jobScheduler.events.selectedToday'
        )}`
      : '';
  }

  private repeatTypeOptions: { [key: string]: any } = {
    noRepeat: {
      repeatTypeText: i18n.tc(
        'jobScheduler.common.repeatType.repeatTypeOptions.noRepeat'
      ),
      repeatTypeValue: RepeatType.NoRepeat,
    },
    daily: {
      repeatTypeText: i18n.tc(
        'jobScheduler.common.repeatType.repeatTypeOptions.daily'
      ),
      repeatTypeValue: RepeatType.Daily,
    },
    monthly: {
      repeatTypeText: i18n.tc(
        'jobScheduler.common.repeatType.repeatTypeOptions.monthly'
      ),
      repeatTypeValue: RepeatType.Monthly,
    },
    weekly: {
      repeatTypeText: i18n.tc(
        'jobScheduler.common.repeatType.repeatTypeOptions.weekly'
      ),
      repeatTypeValue: RepeatType.Weekly,
    },
    firstDayOfMonth: {
      repeatTypeText: i18n.tc(
        'jobScheduler.common.repeatType.repeatTypeOptions.firstDayOfMonth'
      ),
      repeatTypeValue: RepeatType.FirstDayOfMonth,
    },
    lastDayOfMonth: {
      repeatTypeText: i18n.tc(
        'jobScheduler.common.repeatType.repeatTypeOptions.lastDayOfMonth'
      ),
      repeatTypeValue: RepeatType.LastDayOfMonth,
    },
  };

  private week: { [key: string]: string } = {
    mon: i18n.tc('common.week.mon'),
    tue: i18n.tc('common.week.tue'),
    wed: i18n.tc('common.week.wed'),
    thu: i18n.tc('common.week.thu'),
    fri: i18n.tc('common.week.fri'),
    sat: i18n.tc('common.week.sat'),
    sun: i18n.tc('common.week.sun'),
  };
}
